import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/faqService";
const store = {};
const mutations = {
    GET_FAQ_LIST(state, posts) {
        state.faqList = posts.list;
        state.isAdmin = posts.isAdmin;
        state.faaId = posts.faaId;
    },
    UPDATE_FAQ_LIST(state, posts) {
        state.faqList = posts.list;
        state.faaId = posts.faaId;
    }
};
const state = {
    faqList: [],
    faaId: -1,
    isAdmin: false
};
const getters = {};
const actions = {
    getFaqList({ commit }, faaId) {
        axios
            .get(baseUri + '/GetFaqList', { params: { FaaId: faaId } } )
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_FAQ_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    updateFaqList({ commit }, data ) {
        // If groups payload contains deleted groups, remove their FAQs locally before posting
        if (data.groups && Array.isArray(data.groups)) {
            const deletedGroupIds = data.groups.filter(g => g && g.FagDeleted && g.FagId != null).map(g => g.FagId);
            if (deletedGroupIds.length) {
                state.faqList = state.faqList.filter(f => !deletedGroupIds.includes(f.FagId));
            }
        }
        // Only push new FAQ records (FaqId <= 0) that have a non-empty name to prevent accidental blank creations
        if (data.record && (data.record.FaqId === -1 || data.record.FaqId === 0) && (data.record.FaqName || '').trim().length > 0) {
            state.faqList.push({
                FagId: data.record.FagId,
                FagName: data.record.FagName,
                FaqId: data.record.FaqId,
                FaqName: data.record.FaqName,
                FaqAnswer: data.record.FaqAnswer,
                FaqEnabled: data.record.FaqEnabled,
                FaqDeleted: data.record.FaqDeleted
            });
        }
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.faqList));
        formData.append("FaaId", JSON.stringify(data.faaId));
        if (data.groups) {
            formData.append("groups", JSON.stringify(data.groups));
        }
        axios
            .post(baseUri + '/UpdateFaqList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('UPDATE_FAQ_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}